import { getDatabase, ref, onValue, push, onDisconnect, set, serverTimestamp } from "firebase/database";
import { Subscription, fromEvent, timer } from "rxjs";
import { throttleTime } from 'rxjs/operators';
import { getFirebaseApp } from '../firebase';

export class PresenceService {
  db;
  userId;
  connectionRef;
  lastOnlineRef;
  mouseEvents: Subscription;
  timer: Subscription;
  stopOnValue;
  constructor() {
  }

  // Presence is a nice-to-have: it is started from the loadUserSuccess$ effect,
  // so anything thrown here kills that effect stream and the login navigation
  // (and account/payment loads) chained behind it never dispatch. Never throw.
  startTracking(userId) {
    try {
      const app = getFirebaseApp();
      if (!app) return;
      this.db = getDatabase(app);
      const connectedRef = ref(this.db, '.info/connected');
      this.stopOnValue = onValue(connectedRef, (snap) => snap.val() === true ? this.updatePresence('online') : 0);
      this.userId = userId;
      this.lastOnlineRef = ref(this.db, `patients/${this.userId}/lastOnline`);

      this.mouseEvents = fromEvent(document, 'mousemove')
        .pipe(throttleTime(3000))
        .subscribe(x => {
          this.updatePresence('online')
          if (this.timer) {
            this.timer.unsubscribe();
          }
          this.timer = timer(10000).subscribe(() => {
            this.updatePresence('idle');
          });
        })
    } catch (err) {
      console.error('Presence tracking unavailable', err);
    }
  }

  stopTracking() {
    try {
      if (this.timer) {
        this.timer.unsubscribe();
      }
      if (this.mouseEvents) {
        this.mouseEvents.unsubscribe();
      }
      this.updatePresence('offline');
      if (this.stopOnValue) {
        this.stopOnValue();
      }
    } catch (err) {
      console.error('Failed to stop presence tracking', err);
    }
  }

  updatePresence(status: 'online' | 'idle' | 'offline') {
    if (!this.userId || !this.db) return; // ignore until tracking has started


    // stores the timestamp of my last disconnect (the last time I was seen online)
    if (status === 'online') {
      if (!this.connectionRef) {
        this.connectionRef = push(ref(this.db, `patients/${this.userId}/connections`));
      }
      // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)

      // When I disconnect, remove this device
      onDisconnect(this.connectionRef).remove();

      // Add this device to my connections list
      // this value could contain info about the device or a timestamp too
      set(this.connectionRef, status);

      // When I disconnect, update the last time I was seen online
      onDisconnect(this.lastOnlineRef).set(serverTimestamp());
    } else if (status === 'idle') {
      set(this.connectionRef, status);
    }


  }


}
